import _ from 'lodash'
import { Record } from 'immutable'

import { TOGGLE_RIBBON } from './constants'

const RibbonRecord = Record({
    open: true,
})

export default (state = new RibbonRecord(), action = {}) => {
    switch (action.type) {
        case TOGGLE_RIBBON: {
            const show = _.get(action, 'data.show', '')

            return state.set('open', show)
        }
        default:
            return state
    }
}
